/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */

export type PortalNotificationStatus = typeof PortalNotificationStatus[keyof typeof PortalNotificationStatus];


export const PortalNotificationStatus = {
  Unread: 'Unread',
  Read: 'Read',
} as const;
